import { useTranslation } from '@wlb/shared/i18n/useTranslation';
import { Button } from './Button';
import './ui.css';

interface StateBlockProps {
  status: 'loading' | 'empty' | 'error';
  title?: string;
  message?: string | null;
  onRetry?: () => void;
}

/**
 * The loading / empty / error states every list and panel must render.
 */
export function StateBlock({ status, title, message, onRetry }: StateBlockProps) {
  const { t } = useTranslation('admin');

  if (status === 'loading') {
    return (
      <div className="ui-state" role="status">
        <span className="ui-state__message">{t('common.loading')}</span>
      </div>
    );
  }

  const isError = status === 'error';
  const resolvedTitle =
    title ?? (isError ? t('common.errorTitle') : t('common.emptyTitle'));
  const resolvedMessage = message ?? (isError ? null : t('common.emptyMessage'));

  return (
    <div
      className={`ui-state${isError ? ' ui-state--error' : ''}`}
      role={isError ? 'alert' : undefined}>
      <p className="ui-state__title">{resolvedTitle}</p>
      {resolvedMessage ? <p className="ui-state__message">{resolvedMessage}</p> : null}
      {isError && onRetry ? (
        <div className="ui-state__action">
          <Button variant="secondary" small onClick={onRetry}>
            {t('common.retry')}
          </Button>
        </div>
      ) : null}
    </div>
  );
}
